const ajaxURL = adminurl.ajaxurl;
$(function(){

    $('.js-pass-student').on('click', function(e){
        e.preventDefault();


        var dataID = $(this).data('id');

        var data = {
            action: 'pass_student',
            id: dataID
        }

        // Here is the ajax petition.
        jQuery.ajax({
            url : ajaxURL, // Here goes our WordPress AJAX endpoint.
            type : 'post',
            data : data,
            success : function( success ) {

                window.location.reload();

            },
            fail : function( err ) {
                // You can craft something here to handle an error if something goes wrong when doing the AJAX request.
                alert( "There was an error: " + err );
            }
        });

    })

    setTimeout(function(){
        $('.js-all-students-course-details').addClass('hide');
    }, 300);

    $('.js-sd-open-order').on('click', function(){
        var dataID = $(this).data('id');
        console.log(dataID);
        $('.all-students').addClass('hide');
        $('.course-details__wrapper.js-course-orders').addClass('hide');
        $('.course-details__wrapper[data-user="'+ dataID +'"] .js-course-orders').removeClass('d-none')
        $('.card__account--2 .js-course-orders').removeClass('d-none');

    })

    $('.js-open-course-details').on('click', function(){
        var order_id = $(this).data('id');
        $('.js-all-students-course-details').addClass('hide');
        $('.course-details__wrapper .js-course-orders').addClass('hide');
        $('.js-course-orders').addClass('hide');
        $('.card__account--2 .js-course-orders').addClass('d-none');
        $('.js-all-students-course-details[data-order="'+ order_id +'"]').removeClass('hide');
    })

})